export var valuesDataFilterMatchType = ["Equal", "NotEqual", "In", "NotIn", "LessThan", "MoreThan"];
/*

*/ 
//# sourceMappingURL=DataFilterMatchType.js.map